import Row from './row';

class Column {
  constructor($pool, $plugins, columnName, columnMode) {
    this.$pool = $pool;
    this.$plugins = $plugins;
    this.name = columnName;
    this.mode = columnMode;
    this.rows = {};
  }

  connect(rows) {
    this.rows = Object.values(rows).reduce((acc, row) => {
      acc[row.name] = new Row(this.$pool, this.$plugins, row.name).connect(row);

      return acc;
    }, {});

    return this;
  }

  changeMode(mode, newMode, data, next) {
    if (this.mode !== mode) {
      next({
        columnName: this.name,
        mode,
        newMode,
        message: `The current mode ${this.mode} doesn't match to the passed source mode ${mode}`,
      });
      return;
    }

    if (this.mode === newMode) {
      next({
        columnName: this.name,
        mode,
        newMode,
        message: `The ${newMode} mode has been already applied to ${this.name}`,
      });
      return;
    }

    Object.values(this.rows).forEach(row => {
      row.changeMode(mode, newMode, {
        [mode]: data[mode][row.name],
        [newMode]: data[newMode][row.name],
        columnName: this.name,
      });
    });

    this.mode = newMode;
  }
}

export default Column;
